import { useNavigate } from "react-router-dom";

export default function Controls({
  onShuffle,
  onNewGame,
}) {
  const navigate = useNavigate();
  const goHome = () => {
    navigate("/");
  };

  return (
    <div className="container-fluid">
      <div className='puzzle-controls'>
        <img onClick={goHome} className='puzzle-home' src={`${process.env.PUBLIC_URL}/assets/images/puzzle/home.png`} alt="Home" />
        <img onClick={onShuffle} className='puzzle-shuffle' src={`${process.env.PUBLIC_URL}/assets/images/puzzle/shuffle.png`} alt="Shuffle" />
        <img onClick={onNewGame} className='puzzle-shuffle' src={`${process.env.PUBLIC_URL}/assets/images/puzzle/refresh.png`} alt="Refresh" />
        
      </div>
      {/* <button
        onClick={onShuffle}
        className="text-dark"
      >
        <Shuffle />
      </button> */}

      {/* <button
        onClick={onNewGame}
        className="text-dark d-none"
      >
        <RefreshCcw />
      </button> */}
    </div>
  );
}